import React, { Component, Fragment } from 'react'
import { ProfileInfos } from './ProfileInfos'
import { ShippingAddress } from './ShippingAddress'
import { Summary } from './Summary'
import { Payment } from './Payment'
import { FormVirtualVoucher } from './FormVirtualVoucher'
import { Alert } from 'loyal-react'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import CheckoutPlaceholder from './CheckoutPlaceholder'
import Helmet from 'react-helmet'
import MediaQuery from 'react-responsive'
import PaymentClient from './Payment/PaymentBrands/PaymentClient'
import TitleAnnouncer from '../../App/Shell/TitleAnnouncer'

import { SecondFactorAuthentication } from './SecondFactorAuthenticaton'

import slugify from 'react-slugify'

import '@loyal_template/cart.css'
import '@loyal_template/checkout.css'

const paymentDefault = 'POINTS_ONLY'
const cardType = 'direct'

const creditCardDefault = () => ({
  number: '',
  personName: '',
  validityDate: '',
  cvv: ''
})

let brand = {}

class Checkout extends Component {
  constructor (props) {
    super(props)
    this.forceFocus = this.forceFocus.bind(this)
    this.cardBrand = this.cardBrand.bind(this)
    this.setVendorBrands = this.setVendorBrands.bind(this)
    this.updateInstallments = this.updateInstallments.bind(this)
  }
  state = {
    step: 0,
    customer: {},
    paymentSelected: paymentDefault,
    paymentPoints: 0,
    creditCard: creditCardDefault(),
    showModal: true,
    hideModal: true,
    sendGTM: false,
    showPayment: false,
    shippingCalculated: false,
    currentPrice: null,
    errorShipping: false
  }
  componentDidMount () {
    this.props.loadCart()

    this.props.clearError()
    this.props.clearConfirmedOrderData()
    if (this.props.catalogJustCash) {
      this.props.getVisualizationContext()
    }

    setTimeout(() => {
      this.setState({
        showPayment: true
      })
    }, 600)
  }
  clearError = () => {
    this.setState({ errorShipping: false })
  }
  setShippingError = () => {
    this.setState({ errorShipping: true })
  }
  componentDidUpdate (prevProps) {
    if (prevProps.cart !== this.props.cart) {
      if (this.props.cart && this.props.cart.shipping && this.props.cart.shipping.error) {
        this.setShippingError()
      }
    }
    if (!this.state.shippingCalculated && this.props.shipping && this.props.shipping.value === null && this.props.address && (this.props.address.zipCode !== '' && this.props.address.zipCode)) {
      this.props.fetchShipping(this.props.address.zipCode)
      this.shippingCalculated()
    }

    if (this.props.secondFactorAuthSuccess) {
      if (this.props.authorized &&
          (this.props.statusCode !== 500 || this.props.statusCode !== 400)
      ) {
        this.confirm(this.props.confirmedOrderId)
      } else if (this.props.authorized === false) {
        this.props.closeModal()
      }
    }
    if (this.props.cart && this.props.cart.items && this.props.cart.items.length > 0 &&
      !this.state.vendorBrands && !this.props.payment.pointsCashConfig.isLoading && this.props.onlyCash) {
      this.setVendorBrands()
    }
    if (this.props.cart && this.props.cart.items && this.props.cart.items.length > 0 && this.props.onlyCash &&
      this.state.vendorBrands && !this.state.vendorInstallments && !this.state.vendorInstallmentsIsLoading) {
      this.setVendorInstallments()
    }
  }
  shippingCalculated () {
    this.setState({ shippingCalculated: true })
  }
  async setVendorBrands () {
    let vendorBrands = await this.getPaymentsByVendor(this.props.cart.items.find(e => true))
    this.setState({ vendorBrands: vendorBrands })
  }

  async setVendorInstallments () {
    if (this.state.vendorBrands.type === cardType && brand && brand.id) {
      this.setState({ vendorInstallmentsIsLoading: true })
      let parcelas = await this.getInstallments(this.props.cart.items.find(e => true), brand.id)
      this.setState({ vendorInstallments: parcelas, vendorInstallmentsIsLoading: false })
      if (parcelas && parcelas.data && parcelas.data.length > 1) {
        this.setState({ currentPrice: parcelas.data[1] })
      }
    }
  }

  forceFocus = element => {
    let elementFocus = '.logo-header-link'

    const closeModalAcessibility = document.querySelector('.close-accessibility-message')
    const backButtonMobile = document.querySelector('.btn-back-page-mobile')

    if (closeModalAcessibility !== null) {
      elementFocus = '.close-accessibility-message'
    } else if (backButtonMobile !== null) {
      elementFocus = '.btn-back-page-mobile'
    }

    var alertBox = document.querySelector(element || elementFocus)
    var focusInterval = 10 // ms, time between function calls
    var focusTotalRepetitions = 10 // number of repetitions

    alertBox.setAttribute('tabindex', '0')
    alertBox.blur()

    var focusRepetitions = 0
    var interval = window.setInterval(function () {
      alertBox.focus()
      focusRepetitions++
      if (focusRepetitions >= focusTotalRepetitions) {
        window.clearInterval(interval)
      }
    }, focusInterval)
  }

  confirm = id => {
    this.props.redirectConfirmation(id)
    this.props.changePropToSuccess()
  }

  setCustomer = customer => {
    this.setState({
      customer,
      step: 1,
      paymentSelected: paymentDefault
    })
    this.sendGTM()
  }

  selectPointsCash = () => {
    this.setState({
      paymentSelected: 'POINTS_CASH',
      creditCard: creditCardDefault()
    })
    this.removeCouponOnChangePayment()
  }

  selectPointsOnly = () => {
    this.setState({
      paymentSelected: 'POINTS_ONLY',
      creditCard: creditCardDefault()
    })
    this.removeCouponOnChangePayment()
  }

  removeCouponOnChangePayment = () => {
    const { cart, removeCoupon } = this.props
    if (cart.coupon && cart.coupon.code) removeCoupon()
  }

  handleCreditCardChange = ({ target }) => {
    const { name, value } = target
    const creditCard = { ...this.state.creditCard, [name]: value }
    this.setState({ creditCard })
  }

  fetchInstallments = points => {
    const creditCard = { ...this.state.creditCard, installment: null }
    this.setState({ creditCard, paymentPoints: points })

    const { maxPointForCash, totalOrder } = this.props.payment.pointsCashConfig
    const pointsDiff =
      maxPointForCash - points < 0
        ? totalOrder - maxPointForCash
        : totalOrder - points
    this.props.fetchInstallments({ PointsCash: pointsDiff }, (this.props.cart && this.props.cart.coupon && this.props.cart.coupon.code))
  }

  handleStepChange = step => {
    this.setState({ step, paymentSelected: paymentDefault })

    this.sendGTM()
  }

  handleConfirmAddress = shippingAddress => {
    this.props.updateShippingAddress({
      customer: this.state.customer,
      shippingAddress
    })
  }

  installmentSelected = () =>
    this.state.creditCard.installment ||
    this.props.payment.installments.items[2]

  cardBrand = () => {
    const number = this.cardNumber()
    const { cardBrandModel: brands } = this.props.payment.pointsCashConfig

    if (!number) return

    if (this.props.onlyCash && this.state.vendorBrands && this.state.vendorBrands.type !== 'classic') {
      let paymentTypes = this.state.vendorBrands.data
      let cardbrand = paymentTypes && paymentTypes.find(item => RegExp(item.regex).test(number))
      brand = cardbrand && {
        id: cardbrand.idFormaPagamento,
        name: cardbrand.nome,
        imageUrl: cardbrand.urlImage,
        regexValidation: cardbrand.regex
      }
    } else {
      if (!brands) return
      brand = brands.find(item => RegExp(item.regexValidation).test(number))
    }

    return brand
  }

  getPaymentsByVendor = async (item) => {
    let price = this.convertNumber(this.props.cart.priceCash + this.props.cart.shipping.totalCash)
    let data = {
      zip_code: this.props.cart.shippingAddress.zipCode,
      shipment_id: 0,
      cart_total_value: price,
      products: await this.createProductsToSend(this.props.cart)
    }
    return PaymentClient.handleCardbrands(item.vendor.id, data)
  }

  getInstallments = async (item, cardBrand) => {
    let price = this.convertNumber(this.props.cart.priceCash + this.props.cart.shipping.totalCash)
    let data = {
      zip_code: this.props.cart.shippingAddress.zipCode,
      shipment_id: 0,
      cart_total_value: price,
      payment_options: [cardBrand],
      products: await this.createProductsToSend(this.props.cart)
    }
    return PaymentClient.handleInstallments(item.vendor.id, data)
  }

  createProductsToSend = async (cart) => {
    let products = []
    for (let index = 0; index < cart.items.length; index++) {
      let product = {
        quantity: cart.items[index].quantity,
        product_id: await PaymentClient.getOriginalId(cart.items[index].sku)
      }
      products.push(product)
    }
    return products
  }

  convertNumber = (num) => {
    let convertido = num.toFixed(2)
    return Number(convertido)
  }

  updateInstallments = (installments) => {
    if (this.props.onlyCash && this.state && this.state.vendorBrands && this.state.vendorBrands.type === cardType && this.state.vendorInstallments) {
      installments = this.state.vendorInstallments ? this.state.vendorInstallments.data : installments
    }

    return installments
  }

  checkError = error => {
    return error.includes('exception')
      ? 'Tente novamente em instantes'
      : error === '#DoNotShowDescription' ? '' : (error || this.defaultMessageError())
  }

  cardNumber = () => {
    const onlyNumbers = this.state.creditCard.number.match(/\d+/g)
    if (onlyNumbers) return onlyNumbers.join([])

    return ''
  }

  getCvv = () => {
    const onlyNumbers = this.state.creditCard.cvv.match(/\d+/g)
    if (onlyNumbers) return onlyNumbers.join([])

    return ''
  }

  createPurchasePointsCash = () => {
    const { creditCard, paymentPoints } = this.state
    const { totalOrder } = this.props.payment.pointsCashConfig
    const validityDateParts = creditCard.validityDate.split('/')
    const installmentSelected = this.installmentSelected()
    const installments = installmentSelected.parcel
    const pointsValue = this.props.onlyCash
      ? installments * installmentSelected.parcelValue
      : totalOrder - paymentPoints
    const cardBrand = this.cardBrand()
    const cardNumber = this.cardNumber()

    this.props.createPurchase({
      cardBrandId: cardBrand.id,
      cardHolderName: creditCard.personName,
      cardHolderCPF: creditCard.personCPF.replace(/[^0-9 ]/g, ''),
      cardNumber,
      expirationMonth: validityDateParts[0],
      expirationYear: validityDateParts[1],
      securityCode: this.getCvv(),
      installments,
      pointsValue
    })
  }

  createPurchase = () => {
    const { paymentSelected } = this.state
    if (paymentSelected === 'POINTS_ONLY') {
      this.props.createPurchase()
    } else {
      this.createPurchasePointsCash()
    }
  }

  defaultMessageError = () => {
    const messageError = 'Vamos fazer uma nova tentativa?'
    return this.state.paymentSelected === 'POINTS_ONLY'
      ? messageError
      : `${messageError} Verifique os dados do cartão ou tente outro cartão.`
  }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }
  sendGTM () {
    setTimeout(() => {
      const props = this.props.cart

      let step = this.state.step + 2

      if (Object.entries(props.items).length > 0) {
        const productsList = []

        props.items.map((item, index) => {
          let categoryName
          if (item.category) {
            categoryName = item.category.name ? slugify(item.category.name, { delimiter: ' ' }) : undefined
          }
          return (
            productsList.push({
              'name': slugify(item.name, { delimiter: ' ' }),
              'id': item.sku,
              'price': item.price,
              'brand': undefined,
              'category': categoryName,
              'variant': undefined,
              'quantity': item.quantity,
              'coupon': undefined,
              'dimension5': item.vendor ? 'vendor-' + item.vendor.id : undefined,
              'metric2': item.cash ? item.cash.sellingPrice.toFixed(2) : undefined
            })
          )
        })

        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
          'event': 'checkout',
          'eventCategory': 'enhanced-ecommerce',
          'eventAction': 'checkout',
          'ecommerce': {
            'checkout': {
              'actionField': { 'step': step.toString() },
              'products': productsList
            }
          }
        })
      }
    }, 500)
    this.setState({ sendGTM: true })
  }
  render () {
    const showErrorShipping = this.state.errorShipping && (this.props.cart && this.props.cart.shipping && this.props.cart.shipping.error)

    if (this.props.confirmedOrderId !== undefined) {
      if (
        this.props.status !== 'RequiresTokenValidation' &&
        this.props.status !== 'Onboarding' &&
        this.props.status !== 'ResendTokenError' &&
        this.props.secondFactorAuthSuccess !== true &&
        this.props.authorized
      ) {
        this.props.redirectConfirmation(this.props.confirmedOrderId)
      }
    }

    if (this.props.onlyCash && this.state.paymentSelected !== 'CASH_ONLY') {
      this.setState({
        paymentSelected: 'CASH_ONLY'
      })
    }

    const { price, priceCash, shipping, coupon } = this.props.cart
    const totalPoints = Math.max(
      price + (shipping.total || 0) - ((coupon && coupon.totalOfBenefits) || 0),
      0
    )

    const totalCash = priceCash + (shipping.totalCash || 0)

    const totalPrice = {
      points: totalPoints,
      cash: totalCash
    }

    const props = {
      ...this.props,
      ...this.state,
      totalPrice,
      handleStepChange: this.handleStepChange,
      setCustomer: this.setCustomer,
      handleConfirmAddress: this.handleConfirmAddress,
      selectPointsCash: this.selectPointsCash,
      selectPointsOnly: this.selectPointsOnly,
      handleCreditCardChange: this.handleCreditCardChange,
      fetchInstallments: this.fetchInstallments,
      installmentSelected: this.installmentSelected,
      cardBrand: this.cardBrand,
      createPurchase: this.createPurchase,
      updateInstallments: this.updateInstallments
    }

    if (this.state.sendGTM === false) {
      this.sendGTM()
    }

    return (
      <Fragment>
        <Helmet>
          <title>{`Pagamento - ${process.env.REACT_APP_TITLE || ''}`}</title>
          <MediaQuery maxDeviceWidth='1024'>
            <TitleAnnouncer orientation='mobile' />
          </MediaQuery>
          <MediaQuery minDeviceWidth='1025'>
            <TitleAnnouncer orientation='desktop' />
          </MediaQuery>
        </Helmet>
        <ReactPlaceholder
          ready={!this.props.isLoading}
          customPlaceholder={<CheckoutPlaceholder />}
        >

          <div className='container-cart container py-md-5 py-0 px-md-1 px-0'>
            <div className='row mx-0'>
              {props.hasError && props.statusCode !== 406 && (
                <Alert
                  isError
                  title={
                    props.messageError
                      ? props.messageError
                      : 'Não foi possível concluir o seu pagamento.'
                  }
                  description={`${this.checkError(props.subMessageError || '')}`}
                  className='pb-2'
                  onClose={this.props.clearError}
                />
              )}
              { showErrorShipping && (
                <Alert
                  isError
                  title={shipping.error}
                  description={shipping.errorSub}
                  className='pb-2'
                  onClose={() => this.clearError()}
                />
              )}
              <div className='checkout-side col-12 col-lg-8 pl-0 pr-lg-2 pr-0 mt-5 pt-2 mt-sm-0 pt-sm-0'>
                <div className='border-ui-3 radius bg-white'>
                  <div className='row mx-0'>
                    {props.cart.hasItemsDifferentVirtualVoucher ? (
                      <React.Fragment>
                        <ProfileInfos forceFocus={this.forceFocus} {...props} />
                        <MediaQuery minDeviceWidth={1025}>
                          <ShippingAddress forceFocus={this.forceFocus} {...props} orientation='desktop' />
                        </MediaQuery>
                        <MediaQuery maxDeviceWidth={1024}>
                          <ShippingAddress forceFocus={this.forceFocus} {...props} orientation='mobile' />
                        </MediaQuery>
                      </React.Fragment>
                    ) : (
                      <FormVirtualVoucher {...props} />
                    )}
                    {this.state.showPayment && (
                      <React.Fragment>
                        <MediaQuery minDeviceWidth={1025}>
                          <Payment {...props} orientation='desktop' />
                        </MediaQuery>
                        <MediaQuery maxDeviceWidth={1024}>
                          <Payment {...props} orientation='mobile' />
                        </MediaQuery>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <Summary {...props} />
            </div>
            {this.props.confirmedOrderId !== undefined &&
            (this.props.status === 'RequiresTokenValidation') && (
            // eslint-disable-next-line react/jsx-indent
              <div className='modalConfirmationVoucher'>
                <SecondFactorAuthentication
                  show={
                    this.state.showModal && !this.props.secondFactorAuthSuccess
                  }
                  onClose={() => this.toogleModal()}
                  secondFactorAuthConfirmated
                  {...this.props}
                  creditCard={props.creditCard}
                  cardBrand={props.cardBrand}
                  paymentSelected={props.paymentSelected}
                  payment={this.props.payment}
                  paymentPoints={props.paymentPoints}
                  oidc={this.props.oidc}
                />
              </div>
            )}
            {this.props.statusCode === 406 && (
              <div className='modalConfirmationVoucher'>
                <SecondFactorAuthentication
                  show={this.state.showModal && !this.props.secondFactorAuthSuccess}
                  onClose={() => this.toogleModal()}
                  secondFactorAuthConfirmated={false}
                  {...this.props}
                  creditCard={props.creditCard}
                  cardBrand={props.cardBrand}
                  paymentSelected={props.paymentSelected}
                  payment={this.props.payment}
                  paymentPoints={props.paymentPoints}
                  oidc={this.props.oidc}
                />
              </div>
            )}
          </div>
        </ReactPlaceholder>
      </Fragment>
    )
  }
}

Checkout.propTypes = {
  address: PropTypes.object,
  participant: PropTypes.object,
  payment: PropTypes.object,
  cart: PropTypes.object,
  currency: PropTypes.object,
  hasError: PropTypes.bool,
  messageError: PropTypes.string,
  updateShippingAddress: PropTypes.func,
  fetchInstallments: PropTypes.func.isRequired,
  createPurchase: PropTypes.func.isRequired,
  redirectConfirmation: PropTypes.func,
  confirmedOrderId: PropTypes.number,
  status: PropTypes.string,
  statusCode: PropTypes.string,
  errorToken: PropTypes.bool,
  isLoading: PropTypes.bool,
  clearError: PropTypes.func,
  fetchShipping: PropTypes.func,
  resetShipping: PropTypes.func,
  shipping: PropTypes.object,
  loadCart: PropTypes.func,
  removeCoupon: PropTypes.func,
  catalog: PropTypes.object,
  brandsByVendor: PropTypes.object,
  onlyCash: PropTypes.bool,
  authorizeWithToken: PropTypes.func,
  secondFactorAuthSuccess: PropTypes.bool,
  authorized: PropTypes.bool,
  changePropToSuccess: PropTypes.func,
  clearConfirmedOrderData: PropTypes.func,
  closeModal: PropTypes.func,
  oidc: PropTypes.object,
  updateInstallments: PropTypes.func,
  getVisualizationContext: PropTypes.func,
  catalogJustCash: PropTypes.bool
}

export default Checkout



// WEBPACK FOOTER //
// ./src/features/Checkout/Checkout.js